module.exports = __webpack_public_path__ + "img/success-with-circle.9bba244e.svg";